import { render, staticRenderFns } from "./CLoaderFrame.vue?vue&type=template&id=1a8561b4&"
import script from "./CLoaderFrame.vue?vue&type=script&lang=ts&"
export * from "./CLoaderFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports